
import './filterMonthInput.css';
import React, { useState, useEffect } from 'react'

function FilterMonthInput({ placeholder, item, setItem, inactive }) {
    const [calendarActive, setCalendarActive] = useState(false);
    const [labelActive, setLabelActive] = useState(false);

    const calendarActiveChangeHandler = () => {
        setCalendarActive(prev => !prev);
    }
    /*** Calendar Part ***/
    const [monthPicker, setMonthPicker] = useState(() => {
        let currDate = new Date();
        return currDate.getMonth();
    });
    const [yearPicker, setYearPicker] = useState(() => {
        let currDate = new Date();
        return currDate.getFullYear();
    });
    const month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const yearHandle = (type) => {
        if (type === 'add') {
            setYearPicker(prev => prev + 1)
        } else {
            setYearPicker(prev => prev - 1)
        }
    }
    const monthListHandler = (index) => {
        setMonthPicker(index);
        setItem(`${yearPicker}-${index + 1}`);
        setLabelActive(true);
        setCalendarActive(false);
    }
    const removeCalendarDate = () => {
        setLabelActive(false);
        setItem('');
        setCalendarActive(false);
    }
    useEffect(()=>{
        if(item !== ""){
            setLabelActive(true);
        }else{
            setLabelActive(false);
        }
    }, [item])


    return (
        <div className={["filter-month-input", inactive ? 'inactive' : ''].join(' ')}>
            <input type="text" value={item} readOnly />
            <label className={labelActive ? 'active' : ''}>{placeholder}</label>
            <span id='calendar-icon' className="material-symbols-rounded" onClick={calendarActiveChangeHandler}>calendar_month</span>

            <div className={calendarActive ? "calendar-global active" : "calendar-global"}>
                <div className="calendar">
                    <span id="close" onClick={() => setCalendarActive(false)} className="material-symbols-rounded">close</span>
                    {/* <!-- Calendar header --> */}
                    <div className="calendar-header">
                        <span className="month-picker">{month_names[monthPicker]}</span>
                        <div className="year-picker">
                            <span className="year-change" id="prev-year" onClick={() => yearHandle('remove')}>
                                <span className="material-symbols-rounded">chevron_left</span>
                            </span>
                            <span id="year">{yearPicker}</span>
                            <span className="year-change" id="next-year" onClick={() => yearHandle('add')}>
                                <span className="material-symbols-rounded">chevron_right</span>
                            </span>
                        </div>
                    </div>
                    {/* <!-- End Calendar header --> */}


                    {/* <!-- Calendar Months --> */}
                    <div className={"month-list"}>
                        {
                            month_names.map((ele, index) => (
                                <div key={index} onClick={() => monthListHandler(index)}>
                                    <div>{ele}</div>
                                </div>
                            ))
                        }
                    </div>
                    {/* <!-- End Calendar Months --> */}


                    {/* <!-- Calendar footer --> */}
                    <div className="calendar-footer">
                        <span onClick={removeCalendarDate}>Clear</span>
                    </div>
                    {/* <!-- End Calendar footer --> */}
                </div>
            </div>


        </div>
    )
}

export default FilterMonthInput
